import { useMemo } from 'react';
import { useScript } from '../hooks/useScript';
var liveSrc = 'https://pi-live.sagepay.com/api/v1/js/sagepay.js';
var sandboxSrc = 'https://pi-test.sagepay.com/api/v1/js/sagepay.js';
export function useOpayo(sandbox) {
    var loaded = useScript(sandbox ? sandboxSrc : liveSrc);
    return useMemo(function () {
        if (!loaded)
            return undefined;
        return {
            createForm: function (merchantSessionKey, options) {
                if (options === void 0) { options = {}; }
                window
                    .sagepayCheckout({
                    merchantSessionKey: merchantSessionKey,
                    containerSelector: options.containerSelector,
                })
                    .form({ formSelector: options.formSelector });
            },
            tokeniseCardDetails: function (merchantSessionKey, cardDetails) {
                return new Promise(function (resolve, reject) {
                    window.sagepayOwnForm({ merchantSessionKey: merchantSessionKey }).tokeniseCardDetails({
                        cardDetails: cardDetails,
                        onTokenised: function (result) {
                            if (result.success) {
                                resolve(result.cardIdentifier);
                            }
                            else {
                                console.log(result);
                                reject(result);
                            }
                        },
                    });
                });
            },
        };
    }, [loaded]);
}
//# sourceMappingURL=useOpayo.js.map